import React from 'react';
import { Button } from '@mantine/core';
import { ShoppingCart, ExternalLink } from 'lucide-react';
interface Product {
  id: string;
  title: string;
  image: string;
  price: string;
  url?: string;
}
interface RecommendedProductsProps {
  products: Product[];
}
export const RecommendedProducts = ({
  products
}: RecommendedProductsProps) => {
  if (!products || products.length === 0) {
    return null;
  }
  // ChatGPT shopping expert link
  const shoppingExpertLink = 'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert';
  return <div className="mb-4 sm:mb-6 bg-white rounded-lg shadow-sm p-3 sm:p-4 border border-gray-100" data-id="element-189">
      <h2 className="text-sm font-medium text-gray-700 mb-2 sm:mb-3" data-id="element-190">
        Recommended For You
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3" data-id="element-191">
        {products.map(product => <div key={product.id} className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-all" data-id="element-192">
            <a href={shoppingExpertLink} target="_blank" rel="noopener noreferrer" className="block" data-id="element-193">
              <div className="h-24 sm:h-32 overflow-hidden bg-gray-50" data-id="element-194">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover" data-id="element-195" />
              </div>
              <div className="p-2" data-id="element-196">
                <h3 className="text-xs font-medium text-gray-800 line-clamp-2 h-8 sm:h-10" data-id="element-197">
                  {product.title}
                </h3>
                <div className="flex items-center justify-between mt-1 sm:mt-2" data-id="element-198">
                  <span className="text-xs font-bold text-blue-600" data-id="element-199">
                    {product.price}
                  </span>
                  <Button component="a" href={shoppingExpertLink} target="_blank" size="xs" className="bg-blue-600 hover:bg-blue-700 px-1 sm:px-2 py-0 h-5 sm:h-6 min-w-0" data-id="element-200">
                    <ExternalLink size={10} className="sm:hidden" data-id="element-201" />
                    <ExternalLink size={12} className="hidden sm:block" data-id="element-202" />
                  </Button>
                </div>
              </div>
            </a>
          </div>)}
      </div>
    </div>;
};